export default __webpack_public_path__ + "static/patterns-6109ca03fbc12e7750b96b2f6e91ac54.png";